import React from 'react';
import get from 'lodash/get';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/SettingsTwoTone';
import BackIcon from '@material-ui/icons/ArrowBack';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import PeriodLabel from '../PeriodLabel';
import isObject from 'lodash/isObject';
import { Map } from 'immutable';
import orderBy from 'lodash/orderBy';
import usePeriodByDateRange from '../../hooks/usePeriodByDateRange';
import { DatePicker } from '@material-ui/pickers';
import { startOfMonth, endOfMonth, subWeeks } from 'date-fns/esm';

const SelectPeriodDlg = withStyles(theme => ({
  header: {
    color: theme.palette.primary.main
  }
}))(props => {
  const { periods, selectedPeriod, classes, onSelect, onBack, ...other } = props;
  console.log('>>PeriodSelector/index::', 'periods', periods); //TRACE
  const sortedPeriods = orderBy(periods, ['dateFrom'], ['desc']);
  return (
    <Dialog {...other}>
      <DialogTitle>
        <IconButton onClick={onBack}>
          <BackIcon />
        </IconButton>
        <span className={classes.header}>Select Period</span>
      </DialogTitle>
      <div>
        <Divider />
        <List data-testid="periodListSelector">
          {sortedPeriods.map(period => (
            <ListItem
              button
              selected={get(selectedPeriod, 'id') === period.id}
              onClick={() => onSelect && onSelect(period)}
              key={period.id}>
              <ListItemText>
                <PeriodLabel period={period} />
              </ListItemText>
            </ListItem>
          ))}
        </List>
      </div>
    </Dialog>
  );
});

// function Render(props) {
//   const { onClick, day, isSelected } = props;
//   const ref = React.useRef(null);
//   function handleClick(event) {
//     onClick && onClick(day);
//   }
//   console.log('>>WeeksPage/WeekForm::', 'isSelected', isSelected); //TRACE
//   return (
//     <span ref={ref} onClick={handleClick}>
//       {props.children}
//       <Popper open={isSelected} anchorEl={ref.current} style={{ zIndex: 99999 }}>
//         <Paper>
//           <Typography>The content of the Popper.</Typography>
//         </Paper>
//       </Popper>
//     </span>
//   );
// }

// function PeriodPicker(props) {
//   const [{ selectedDate }, setState] = React.useState({ selectedDate: null });
//   console.log('>>WeeksPage/WeekForm::', 'selectedDate', selectedDate); //TRACE
//   const onClickDay = React.useCallback(day => {
//     setState(oldState => ({ ...oldState, selectedDate: day }));
//   }, []);
//   return (
//     <DatePicker
//       label="With server data"
//       onChange={event => {
//         console.log('>>WeeksPage/WeekForm::', 'event', event);
//       }}
//       renderDay={(day, _selectedDate, isInCurrentMonth, dayComponent) => {
//         // console.log('>>WeeksPage/WeekForm::', '_selectedDate', _selectedDate); //TRACE
//         const isSelected = day.toISOString() === _selectedDate.toISOString();
//         return (
//           <Render day={day} isSelected={isSelected} onClick={onClickDay}>
//             {dayComponent}
//           </Render>
//         );
//       }}
//     />
//   );
// }

export default props => {
  const { value: selectedPeriodId, asButton = false, onChange } = props;
  const [state, setState] = React.useState(
    Map({ open: false, dateOpen: false, startDate: null, endDate: null })
  );

  // const { data } = useListPeriods();
  const startDate = state.get('startDate');
  const endDate = state.get('endDate');
  const { periodList, loading, weekRange } = usePeriodByDateRange({
    startDate,
    endDate
  });
  const selectedPeriod = React.useMemo(() => {
    if (!selectedPeriodId) return;
    if (isObject(selectedPeriodId)) return selectedPeriodId;

    return periodList.find(p => {
      return p.id === selectedPeriodId;
    });
  }, [selectedPeriodId, periodList]);
  console.log(
    '>>PeriodSelector/index::',
    'periodList',
    periodList,
    selectedPeriod,
    selectedPeriodId
  ); //TRACE
  const open = state.get('open');
  const dateOpen = state.get('dateOpen');
  const onPeriodChange = React.useCallback(
    period => {
      onChange && onChange(period);
      setState(oldState => oldState.set('open', false));
    },
    [onChange]
  );
  const onDateClick = React.useCallback(() => {
    setState(oldState => oldState.set('open', false));
    setState(oldState => oldState.set('dateOpen', !dateOpen));
  }, [dateOpen]);
  const onClick = React.useCallback(() => {
    setState(oldState => oldState.set('open', !open));
    setState(oldState => oldState.set('dateOpen', false));
  }, [open]);
  const onClose = React.useCallback(() => {
    setState(oldState => oldState.set('open', false));
    setState(oldState => oldState.set('dateOpen', false));
  }, []);
  const handleDateChange = e => {
    setState(oldState => oldState.set('startDate', subWeeks(startOfMonth(e), 1)));
    setState(oldState => oldState.set('endDate', endOfMonth(e)));
    onClick();
  };

  if (loading) return <span>Getting weeks...</span>;
  return (
    <>
      <SelectPeriodDlg
        open={open}
        // open
        selectedPeriod={selectedPeriod}
        periods={periodList}
        onClose={onClose}
        onBack={onDateClick}
        onSelect={onPeriodChange}
        weekRange={weekRange}
      />
      <DatePicker
        style={{ display: 'none' }}
        open={dateOpen}
        onClose={() => setState(oldState => oldState.set('dateOpen', false))}
        onChange={handleDateChange}
        onMonthChange={handleDateChange}
        views={['year', 'month']}
      />
      <span data-testid="WABSelectWeekBtn">
        <PeriodLabel period={selectedPeriod} asButton={asButton} onClick={onDateClick} />
      </span>
      {!asButton && (
        <IconButton size="small" color="primary" onClick={onDateClick}>
          <EditIcon />
        </IconButton>
      )}
    </>
  );
};
